/*window.onbeforeunload = function () {
    window.scrollTo(0, 0);
}*/

$( document ).ready(function() {
    /*$('#fullpage').fullpage({
        scrollOverflow: true
    });*/
    //$(this).scrollTop(0);

  if (Cookies.get('intro') === 'false') {
    $('.first-section').toggleClass('open', false);
    $('.menu').toggleClass('hidden', false);
    $('.no-scroll').toggleClass('no-scroll', false);
  } else {
    if($('body').hasClass('home')){
      var animation = bodymovin.loadAnimation({
        container: document.getElementById('bm'),
        renderer: 'svg',
        loop: false,
        autoplay: true,
        path: dataurl+'assets/js/data.json'
      });
    }

    setTimeout(function () {
      $('.first-section').toggleClass('open', false);
      $('.menu').toggleClass('hidden', false);
      $('.no-scroll').toggleClass('no-scroll', false);
    }, 8000);

    var date = new Date();
    date.setTime(date.getTime() + (10 * 60 * 1000));
    Cookies.set('intro', false, {expires: date});
  }

    var interval = '';
    var num = 0;
    var count = 0;
    var startTimeout = '';
    $('.one-third-link').hover(function () {


        count = $(this).children('.fading-cont').children('.element').length;

        $(this).children('.fading-cont').children('.element:nth-child(1)').toggleClass('zoom', true).toggleClass('animate', true);
        startTimeout = setTimeout(function () {
            $(this).children('.fading-cont').children('.element:nth-child(1)').toggleClass('hidden', true);
            $(this).children('.fading-cont').children('.element:nth-child(2)').toggleClass('zoom', true).toggleClass('animate', true);
        }.bind(this), 750);




        num++;

        if(num > count){
            num = 0;
        }

        var that = this;

        interval = setInterval(function () {
            num++;
            if(num > count){
                num = 1;
            }
            //console.log(count, num);

            $(that).children('.fading-cont').children('.element:nth-child('+num+')').toggleClass('zoom', true).toggleClass('animate', true);
            startTimeout = setTimeout(function () {
                $(that).children('.fading-cont').children('.element:nth-child('+num+')').toggleClass('hidden', true);
                $(that).children('.fading-cont').children('.element:nth-child('+( num + 1) +')').toggleClass('zoom', true).toggleClass('animate', true);
            }.bind(this), 750);


            /*if(num-1 < 0){
                setTimeout(function () {
                    $(that).children('.fading-cont').children('.element:nth-child('+count+')').toggleClass('zoom', false).toggleClass('animate', false).toggleClass('hidden', false);

                }, 1500)
            }else{
                setTimeout(function () {
                    $(that).children('.fading-cont').children('.element:nth-child('+(num-1)+')').toggleClass('zoom', false).toggleClass('animate', false).toggleClass('hidden', false);
                }, 1500)
            }*/


        }, 1500);

    }, function () {
        $('.fading-cont .element').toggleClass('zoom', false).toggleClass('animate', false).toggleClass('hidden', false)
        clearInterval(interval);
        clearTimeout(startTimeout);
        num = 0;
    });

    $('.menu #nav-icon4, .menu-button').click(function(){
        $('#nav-icon4').toggleClass('open');
        $('.menu').toggleClass('open');
        $('.menu-overflow').toggleClass('open');
    });

    $('.black-box .title').matchHeight();

    if ($('.elements').length) {
        var macy = Macy({
            container: '.elements',
            trueOrder: true,
            margin: 90,
            columns: 2,
            breakAt: {
                1300: 2,
                767: 1,
            }
        });
    }

    var small  = $('.smallowl');
    small.owlCarousel({
        loop:true,
        margin:0,
        nav:false,
        dots: false,
        items:1,
        smartSpeed: 500,
        dotsContainer: '.owl-dots-cont',
    });

    var owl  = $('.big-carousel');
    owl.owlCarousel({
        loop:false,
        margin:0,
        nav:false,
        dots: false,
        items:1,
        smartSpeed: 500,
        lazyLoad: true,
        onChanged: showHide,
        onload: showHide,
        URLhashListener:true,
        startPosition: 'URLHash'
    });

    $('.next-button').click(function() {
        owl.trigger('next.owl.carousel');
    });

    $('.back-button, .go-back').click(function() {
        owl.trigger('prev.owl.carousel');
    });

    $('.left').click(function () {
        $(this).parent('.more-info-overlay').children('.container').children('.smallowl').trigger('prev.owl.carousel');
    });

    $('.right').click(function () {
        $(this).parent('.more-info-overlay').children('.container').children('.smallowl').trigger('next.owl.carousel');
    });


    $('.ticket-side .close-side').click(function () {
        $(this).parent('.ticket-side').toggleClass('closed', true);
    });

    function showHide(event) {
        //console.log(event.item.index, event.item.count)
        if ( event.item.count > 1 ) {
            $('.next-button').show();
            $('.back-button').show();

            $('.next-button').removeClass('disabled');
            $('.back-button').removeClass('disabled');
            if ( event.item.index == 0 ) {
                $('.back-button').addClass('disabled');
            }
            if ( event.item.index >= 1 ) {
                $('.look-ex').toggleClass('hidden', false);
                $('.timeline').toggleClass('hidden', false);
                $('.timeline-line').toggleClass('hidden', false);
                $('.next-button.home').toggleClass('disabled', true);
            }else{
                $('.timeline').toggleClass('hidden', true);
                $('.timeline-line').toggleClass('hidden', true);
                $('.look-ex').toggleClass('hidden', true);
                $('.next-button.home').toggleClass('disabled', true);
            }
            if ( event.item.index == event.item.count - 1 ) {
                $('.next-button').toggleClass('disabled', true);
                setTimeout(function () {
                    $('.next-button.home').toggleClass('disabled', false);
                }, 1000);
                $('.timeline').toggleClass('hidden', true);
                $('.timeline-line').toggleClass('hidden', true);
                $('.look-ex').toggleClass('hidden', true);
                if($(window).width() < 992){
                    $('.back-button').toggleClass('disabled', true);
                }
            }else{
                $('.home-button').toggleClass('disabled', false);
            }
            if ( event.item.index == event.item.count - $('.big-carousel .item.dark-bg').length ) {

                $('body').toggleClass('dark', true);
                $('.timeline').toggleClass('hidden', true);
                $('.timeline-line').toggleClass('hidden', true);
                $('.look-ex').toggleClass('hidden', true);
                if($(window).width() < 992){
                    $('.back-button').toggleClass('disabled', true);
                }
                $('.home-button').toggleClass('disabled', true);
            }else{
                if(event.item.index != event.item.count - 1){
                    $('body').toggleClass('dark', false);
                }
            }

            $('.event').toggleClass('open', false);


            $('.event:nth-child('+event.item.index+')').toggleClass('open', true)

        } else {
            $('.next-button').hide();
            $('.back-button').hide();
        }
    }

    $('.close-btn').click(function () {
        $(this).parent('.more-info-overlay').toggleClass('hidden', true);
    });

    $('.learn-more').click(function () {
        var open = $(this).data('open');
        $('[data-overlay="'+open+'"]').toggleClass('hidden', false);
    });

    $('.look-ex').click(function () {
        var open = $(this).data('open');
        $('[data-side="'+open+'"]').toggleClass('closed', false);
    });

    $('.dot').click(function() {
        var owl = $(this).closest('.smallowl');
        var data = $(this).data('pos');
        owl.trigger('to.owl.carousel', [data, 1000]);
    });

});
